export * from './StrapiHeroWidget'
